import React from 'react'
import { useDeleteShipperStrikePriceOverride } from 'apps/marketplace/apiTypes/shipperStrikePriceOverrides'
import { FormModal } from 'transfix-ui'

interface IModalProps {
  overrideId?: number
  onClose: () => void
  onRequestSuccess: () => void
}

export const StrikePriceDeleteOverrideModal = ({
  onClose,
  onRequestSuccess,
  overrideId,
}: IModalProps) => {
  const { error, loading, mutate: deleteStrikePriceOverride } = useDeleteShipperStrikePriceOverride(
    {}
  )

  const deleteOverride = async () => {
    await deleteStrikePriceOverride(overrideId || 0)
    onRequestSuccess()
  }

  return (
    <FormModal
      size={4}
      open
      onClose={onClose}
      error={error?.message}
      title='Are you sure?'
      actions={[
        {
          type: 'dismiss',
          label: 'Cancel',
          dataTest: 'cancel-button',
          action: onClose,
          disabled: loading,
        },
        {
          type: 'confirm',
          label: 'Delete',
          dataTest: 'delete-confirm-button',
          action: deleteOverride,
          disabled: loading,
        },
      ]}>
      <span>Are you sure you want to delete this override?</span>
    </FormModal>
  )
}
